import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

type Props = {
  onRetry: () => void;
};

/**
 * Shown in place of a funnel screen, not on top of it: the steps behind it end in signup calls the API refuses
 * without a funnel, and the resume screen has nowhere to send anybody until the read comes back.
 */
export const SignupStepUnavailable: React.FC<Props> = ({ onRetry }) => (
  <Box maxWidth={520} mx="auto">
    <Typography variant="h4" fontWeight="fontWeightSemiBold" gutterBottom>
      We could not pick up where you left off
    </Typography>
    <Stack spacing={3}>
      <Alert severity="error">
        Your signup is fine — we just could not reach it. Nothing has been lost and nothing has been charged.
      </Alert>
      <Typography variant="body1" color="text.secondary">
        Try again in a moment. If it keeps failing, close the tab and come back later — you will land on the
        same step.
      </Typography>

      <Box display="flex" justifyContent="flex-end">
        <Button variant="contained" size="large" onClick={onRetry}>
          Try again
        </Button>
      </Box>
    </Stack>
  </Box>
);
